import { render, staticRenderFns } from "./UploadAction.vue?vue&type=template&id=3ec1b8fc"
import script from "./UploadAction.vue?vue&type=script&lang=js"
export * from "./UploadAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports